export default __webpack_public_path__ + "static/11-978003a3c063c80d571c5f3af65cb6ad.png";